export enum AUTH_ACTION_NAMES {
  LOGIN = '[AUTH] LOGIN',
  LOGIN_SUCCESS = '[AUTH] LOGIN_SUCCESS',
  LOGIN_FAILURE = '[AUTH] LOGIN_FAILURE',

  LOGOUT = '[AUTH] LOGOUT',
  LOGOUT_SUCCESS = '[AUTH] LOGOUT_SUCCESS',

  SET_DESTINATION_URL = '[AUTH/APP] SET_DESTINATION_URL',
  SET_JWT_TOKEN = '[AUTH/APP] SET_JWT_TOKEN',
  SET_ADMIN = '[AUTH/APP] SET_ADMIN',
  LOGIN_WITH_GOOGLE = 'LOGIN_WITH_GOOGLE',
  LOGIN_WITH_GOOGLE_SUCCESS = 'LOGIN_WITH_GOOGLE_SUCCESS',
  LOGIN_WITH_GOOGLE_FAILURE = 'LOGIN_WITH_GOOGLE_FAILURE',

  LOGIN_WITH_EMAIL = 'LOGIN_WITH_EMAIL',
  LOGIN_WITH_EMAIL_SUCCESS = 'LOGIN_WITH_EMAIL_SUCCESS',
  LOGIN_WITH_EMAIL_FAILURE = 'LOGIN_WITH_EMAIL_FAILURE',

  SIGN_UP_WITH_EMAIL = 'SIGN_UP_WITH_EMAIL',
  SIGN_UP_WITH_EMAIL_SUCCESS = 'SIGN_UP_WITH_EMAIL_SUCCESS',
  SIGN_UP_WITH_EMAIL_FAILURE = 'SIGN_UP_WITH_EMAIL_FAILURE',

  CLEAR_ERROR = '[AUTH] CLEAR_ERROR',
}
